import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {
    CampaignsServiceModuleName,
    ContactProfileModuleName,
    LeadModuleName,
    LeadProfileModuleName
} from "../utils/names/optionalModuleNames";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {LeadsController} from "./controller/root/LeadsController";
import {LeadsControllerName} from "../utils/names/serviceNames";
import {NavigationItem} from "../main/model/navigationItem";
import {getTabName} from "modules/utils/TabNameUtils";

export const LeadModuleConfiguration = new RestrictedRouteModuleConfiguration(
    LeadModuleName,
    [
        LeadModuleName,
        LeadProfileModuleName,
        CampaignsServiceModuleName,
        ContactProfileModuleName
    ],
    [
        ["/leads", {
            template: LeadsController.template,
            controller: LeadsControllerName
        }]
    ],
    [new NavigationItem({
        title: "Leads",
        href: "#!leads",
        activeFunction: (routeName) => {
            return routeName.indexOf("leads") !== -1;
        }
    })],
    [LeadModuleName],
    [UserGranredAuthorityName.LEADS],
    getTabName() + '| Leads'
);

export default LeadModuleConfiguration;